import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService } from '../service/file-capture.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { ProgressService } from 'app/service/progress.service';
import { AuthService } from 'app/service/auth-service';
import { map } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  error: boolean = false;
  progressMessage: string;
  referenceForm: FormGroup = new FormGroup({
    referenceNumber: new FormControl('', [Validators.required, Validators.maxLength(60)])
  });
  isUrlDisabled: boolean = true;
  securityCode: any;
  showLoader: boolean = true;
  payorKey: number;

  constructor(private route: Router, private service: FileServiceService,
    private fcservice : FileCaptureService, private ngxspinner : NgxSpinnerService, private authService: AuthService, 
    private router: Router) {
      this.ngxspinner.show();
      this.securityCode = router.url.replace("/", "");
      this.authService.setIsLoggedIn(false);
   }

  ngOnInit() {
    let refId = this.service.referenceFileDetails.referenceId;

    if (!refId) {
      refId = window.localStorage.getItem('referenceId') || '';
      this.service.referenceFileDetails.referenceId = refId;
    }

    this.referenceForm.get('referenceNumber')?.setValue(refId);

    this.fcservice.getPayorIdByCode(this.securityCode).subscribe((result) => {
      this.showLoader = false;
      this.ngxspinner.hide();
      if (result == null) {
        this.isUrlDisabled = true;
        return;
      }
      
      this.payorKey = result;
      window.localStorage.setItem('securityCode', this.securityCode);
      this.isUrlDisabled = false;
    }, error => {
      this.showLoader = false;
      this.ngxspinner.hide();
    });
  }



  clear() {
    this.referenceForm.get('referenceNumber')?.setValue('');
    this.error = false;
  }

  Next(){
    this.ngxspinner.show()
    this.service.referenceFileDetails.referenceId = this.referenceForm.get('referenceNumber')?.value;
    this.service.setCacheForitems(
      [{id:"referenceId", value:this.service.referenceFileDetails.referenceId}]
  );
    if(this.referenceForm.get('referenceNumber')){
      this.fcservice.getReferenceId(this.referenceForm.get('referenceNumber')?.value, this.payorKey).subscribe((res) => {
        this.ngxspinner.hide()
        if(res){
          this.route.navigate(['reference']); 
        }else{
          this.ngxspinner.hide();
          this.error = true;
        }
      }, error => {this.ngxspinner.hide()});
    }
  }

}
